// === Data Type Pattern Matching (using existing schema) ===
export function matchDataType(dataType, matchers) {
    if (!dataType) {
        return matchers.None();
    }
    switch (dataType.type) {
        case "EnumData":
            return matchers.EnumData(dataType);
        case "PrimitiveData":
            return matchers.PrimitiveData(dataType);
        default: {
            return matchers.None();
        }
    }
}
// === Display Type Pattern Matching (using existing schema types) ===
export function matchFieldDisplay(fieldParameter, matchers) {
    const { display } = fieldParameter;
    if ("type" in display) {
        switch (display.type) {
            case "SelectField":
                return matchers.SelectField(display, fieldParameter);
            case "InputField":
                return matchers.InputField(display, fieldParameter);
            case "SelectAccountField":
                return matchers.SelectAccountField(display, fieldParameter);
            case "DueDateInputField":
                return matchers.DueDateInputField(display, fieldParameter);
            case "RadioButtonField":
                return matchers.RadioButtonField(display, fieldParameter);
            default:
                return matchers.Default(fieldParameter);
        }
    }
    return matchers.Default(fieldParameter);
}
// === Primitive Format Pattern Matching (using existing schema) ===
export function matchPrimitiveFormat(dataType, matchers) {
    switch (dataType.format) {
        case "String":
            return matchers.String(dataType);
        case "Number":
            return matchers.Number(dataType);
        case "DollarAmount":
            return matchers.DollarAmount(dataType);
        case "Date":
            return matchers.Date(dataType);
        case "SSN":
            return matchers.SSN(dataType);
        case "PhoneNumber":
            return matchers.PhoneNumber(dataType);
        case "Percentage":
            return matchers.Percentage(dataType);
        default:
            return matchers.Default(dataType);
    }
}
//# sourceMappingURL=patternMatching.js.map